/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：441
 */

var r = require(/* 825 */"../1609/825")
var o = require(/* 424 */"../1720/424")
module.exports = function (e) {
  return r(o(e))
}
